export default {
  BookingWidgets__BUTTON_GROUP_ARIA_NEXT: "Next",
  BookingWidgets__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
  BookingWidgets__HEADING: "Book",
};
